import { Company } from './company';
import { Moment } from 'moment';

export class Shift {
    id: number;
    company: Company;
    type: string;
    started: Moment;
    ended: Moment;
}